import React from "react";

import { Icon } from "../../Icon";
import { DatePickerActionsProps } from "../types";
import { ActionsWrapper, ApplyButton, CancelButton } from "./styles";

/**
 * Componente DatePickerActions
 *
 * Botões de ação para um componente de seleção de datas, permitindo limpar ou confirmar a seleção.
 *
 * @param {() => void} onClear - Função executada ao clicar no botão de limpar.
 * @param {() => void} onConfirm - Função executada ao clicar no botão de confirmar.
 * @param {string} [clearLabel='Limpar'] - Texto exibido no botão de limpar.
 * @param {string} [confirmLabel='Confirmar'] - Texto exibido no botão de confirmar.
 * @param {keyof typeof theme.colors.primary | keyof typeof theme.colors.support} [clearColor='error'] - Cor do botão de limpar.
 * @param {keyof typeof theme.colors.primary | keyof typeof theme.colors.support} [confirmColor='success'] - Cor do botão de confirmar.
 */
export const DatePickerActions: React.FC<DatePickerActionsProps> = ({
  onClear,
  onConfirm,
}) => (
  <ActionsWrapper>
    <CancelButton onClick={onClear} aria-label="Limpar seleção de datas">
      <Icon library="cg" name="CgTrashEmpty" color="mediumGray" size="large" />
    </CancelButton>
    <ApplyButton onClick={onConfirm} aria-label="Confirmar seleção de datas">
      <Icon library="md" name="MdCheck" color="mediumGray" size="large" />
    </ApplyButton>
  </ActionsWrapper>
);
